<template lang="en-us">
    <div class="loading-box">
      <img src="../assets/logored.png" class="loader-logo"/>
      <p class="loader-title-tag pc">Welcome to Projecto Managers</p>
      <p class="loader-subtitle-tag">Africa Leaders in Projects Execution</p>
    </div>
</template>
<script>
export default {
    name:"LoaderComp"
}
</script>
<style>
@import url('../styles/loader.css');
</style>